import { render } from "./zdspDetail.vue?vue&type=template&id=ddf90d74&scoped=true"
import script from "./zdspDetail.vue?vue&type=script&lang=js"
export * from "./zdspDetail.vue?vue&type=script&lang=js"

import "./zdspDetail.vue?vue&type=style&index=0&id=ddf90d74&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf90d74"]])

export default __exports__